import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from "react-helmet";

export class Head extends React.Component {
    render() {
        return (
            <Routes>
                <Route path='/create/' element={
                    <Helmet>
                        <title>Create Video | Specterr</title>
                    </Helmet>
                } />
                <Route path='/videos/' element={
                    <Helmet>
                        <title>My Videos | Specterr</title>
                    </Helmet>
                } />
                <Route path='/password-reset/' element={
                    <Helmet>
                        <title>Password Reset | Specterr</title>
                    </Helmet>
                } />
                <Route path='/password-change/' element={
                    <Helmet>
                        <title>Password Change | Specterr</title>
                    </Helmet>
                } />
                <Route path='/plans/' element={
                    <Helmet>
                        <title>Plans | Specterr</title>
                    </Helmet>
                } />
                <Route path='/account/' element={
                    <Helmet>
                        <title>Account | Specterr</title>
                    </Helmet>
                } />
                <Route path='/not-found/' element={
                    <Helmet>
                        <title>Not Found | Specterr</title>
                    </Helmet>
                } />
                <Route path='/exports/' element={
                    <Helmet>
                        <title>Exports | Specterr</title>
                    </Helmet>
                } />
                <Route path='/support/' element={
                    <Helmet>
                        <title>Support | Specterr</title>
                    </Helmet>
                } />
            </Routes>
        );
    }
}